export default {"src":"/_next/static/media/adult-pool.8e6f88e9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};